import React, { Component } from 'react';
import ActiveConsentList from "../consentsList/activeConsentsList/ActiveConsentsList.container";
import ActivePriorConsentsList from "../consentsList/priorConsentsList/ActivePriorConsentsList.container";

class CurrentConsents extends Component {
    render() {
        return (
            <div className="groups-management-container">
                <ActiveConsentList/>
                <div className="brain-chain-divider"/>
                <ActivePriorConsentsList/>
            </div>
        );
    }
}

export default CurrentConsents;



// WEBPACK FOOTER //
// ./src/components/consentManagement/currentConsents/CurrentConsents.js